import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Calendar, Check, Clock, Dumbbell, Users, Zap } from 'lucide-react';
import { Seo } from '../components/Seo';
import { SEASON } from '../data/site';
import { GROUP_PROGRAMS, HIGH_SCHOOL_FLYER, SPEED_SCHOOL } from '../data/programs';
export function Programs() {
  return <div className="w-full bg-white" data-id="element-854" data-mp="2zfapr14ebzct">
      <Seo title="Fall Programs and Class Times | Reach Performance McKinney" description="High school Advanced Performance and Homeschool Multisport training in McKinney, TX. Fall 2026 runs September 1 to December 17. Book a free athlete evaluation." path="/programs" data-id="element-855" data-mp="3n4d4o17nbe3m" />
      <Hero data-id="element-856" data-mp="3idn0usevbjb1" />
      <SeasonIntro data-id="element-857" data-mp="3idenkzeu2bzb" />
      <ProgramSections data-id="element-858" data-mp="3icv6tm0x5tmv" />
      <SpeedSchoolCallout data-id="element-859" data-mp="3ic3k70pav68q" />
      <Methodology data-id="element-860" data-mp="3iba9xpr4tylu" />
      <NextStepBand data-id="element-861" data-mp="9y39y01o6cz5" />
    </div>;
}
function Hero() {
  return <section className="relative overflow-hidden bg-reach-black" data-id="element-862" data-mp="9vqkl1tl10c2">
      <div className="pointer-events-none absolute inset-0 overflow-hidden" data-id="element-863" data-mp="epcz6zjb3eai">
        <div className="absolute top-1/4 -left-40 h-1.5 w-[50%] -rotate-[6deg] bg-reach-red opacity-50" data-id="element-864" data-mp="zyia8jzwa8ij" />
        <div className="absolute top-[42%] -left-40 h-1.5 w-[35%] -rotate-[6deg] bg-reach-red opacity-30" data-id="element-865" data-mp="v0ynevp4snez" />
        <div className="absolute top-[60%] -left-40 h-1.5 w-[25%] -rotate-[6deg] bg-reach-red opacity-20" data-id="element-866" data-mp="19q4qwvv04zso" />
      </div>
      <div className="relative z-10 mx-auto flex h-[280px] max-w-container flex-col items-center justify-center px-4 text-center md:h-[320px] md:px-8" data-id="element-867" data-mp="14ws8j3gx1p8d">
        <p className="mb-4 font-inter text-xs font-semibold uppercase tracking-[0.3em] text-reach-red-light" data-id="element-868" data-mp="1eopiy803od61">
          {SEASON.label} · {SEASON.range}
        </p>
        <h1 className="mb-3 font-bebas text-6xl leading-none tracking-wide text-white md:text-8xl" data-id="element-869" data-mp="1sluuuomhw697">
          Fall Programs
        </h1>
        <p className="max-w-2xl font-inter text-base text-white md:text-xl" data-id="element-870" data-mp="3ueskkbkz6ipx">
          High school and homeschool training at INPOWERiQ in McKinney.
        </p>
      </div>
    </section>;
}
function SeasonIntro() {
  return <section className="bg-white py-16 md:py-20" data-id="element-871" data-mp="1tee61mxy82v8">
      <div className="mx-auto max-w-3xl px-4 text-center md:px-8" data-id="element-872" data-mp="1yc5z4kabxv10">
        <p className="font-inter text-lg leading-relaxed text-reach-black md:text-xl" data-id="element-873" data-mp="1ycfny4jn1w54">
          Two ongoing groups run through the fall season. Every athlete starts with a free
          evaluation, then trains in a capped small group and is tested every 4 weeks on force
          plates and speed gates.
        </p>
      </div>
    </section>;
}
function ProgramSections() {
  return <section className="bg-reach-gray py-20 md:py-28" data-id="element-874" data-mp="2h9gxm2o50kfe">
      <div className="mx-auto max-w-container space-y-12 px-4 md:space-y-16 md:px-8" data-id="element-875" data-mp="2m18dnj9o37ra">
        <div className="text-center" data-id="element-876" data-mp="2q33p3glbb1is">
          <p className="mb-3 font-inter text-xs font-semibold uppercase tracking-[0.3em] text-reach-red" data-id="element-877" data-mp="2q220safacij4">
            Programs And Class Times
          </p>
          <h2 className="font-bebas text-4xl tracking-wide md:text-6xl" data-id="element-878" data-mp="301j80wa6r4h7">Choose Your Group</h2>
        </div>

        {GROUP_PROGRAMS.map((program, index) => <article key={program.id} id={program.id} className="grid grid-cols-1 overflow-hidden border border-black/10 bg-white lg:grid-cols-[0.9fr_1.1fr]" data-id="element-879" data-mp="3a714e9nga0a4" data-mpi={index}>
            {index === 0 ? <div className="bg-reach-black" data-id="element-880" data-mp="2w5otwdr26qvm">
                <img src={HIGH_SCHOOL_FLYER} alt="Reach Performance high school flyer: every sport, Tuesday and Thursday, capped at 10, small-group strength and speed coaching from 5:45 to 7:00 PM at INPOWERiQ in McKinney" className="mx-auto h-full max-h-[560px] w-full object-contain" loading="lazy" decoding="async" data-id="element-881" data-mp="2w705gzqqx2xa" />
              </div> : <div className="relative min-h-[260px] overflow-hidden bg-reach-black lg:min-h-full" data-id="element-882" data-mp="fgt5b0r9svyz">
                <img src="https://cdn.magicpatterns.com/uploads/aE79ddngrTZ7D6SZfJc3w6/DSC08251.jpg" alt="Homeschool athletes training in a coached small group at INPOWERiQ" className="absolute inset-0 h-full w-full object-cover" style={{
            filter: 'grayscale(0.4) contrast(1.15) saturate(0.7)'
          }} loading="lazy" decoding="async" data-id="element-883" data-mp="apt61ouoi1tb" />
                <div className="absolute left-0 top-0 h-1.5 w-16 bg-reach-red" data-id="element-884" data-mp="3mewa9buwwwge" />
              </div>}

            <div className="flex flex-col p-8 md:p-12" data-id="element-885" data-mp="e15hfae9h20w">
              <p className="mb-4 font-inter text-xs font-semibold uppercase tracking-[0.3em] text-reach-red" data-id="element-886" data-mp="iwunlwksdh66">
                {program.eyebrow}
              </p>
              <h3 className="mb-4 font-bebas text-4xl leading-none tracking-wide md:text-5xl" data-id="element-887" data-mp="97ujjyrffvl4">
                {program.title}
              </h3>

              <div className="mb-6 flex flex-wrap items-center gap-x-5 gap-y-2 font-inter text-sm text-reach-black/70" data-id="element-888" data-mp="ww412ohlxx6g">
                <span className="flex items-center gap-1.5" data-id="element-889" data-mp="11qhzz0vhamfv">
                  <Clock size={14} className="text-reach-red" aria-hidden="true" data-id="element-890" data-mp="2mdr6azm5gq9o" />
                  <span className="uppercase tracking-wider" data-id="element-891" data-mp="2hg937putd59l">{program.duration}</span>
                </span>
                <span className="flex items-center gap-1.5" data-id="element-892" data-mp="2w4vmu3rh4j6m">
                  <Users size={14} className="text-reach-red" aria-hidden="true" data-id="element-893" data-mp="2r5iyfekyf41x" />
                  <span className="uppercase tracking-wider" data-id="element-894" data-mp="2r7lx0n06a5i9">{program.cap}</span>
                </span>
              </div>

              <p className="mb-7 font-inter text-base leading-relaxed text-reach-black" data-id="element-895" data-mp="1ygvatccqg2l7">
                {program.body}
              </p>

              <div className="mb-7" data-id="element-896" data-mp="2df5t7jzg63ga">
                <h4 className="mb-3 flex items-center gap-2 font-inter text-xs font-semibold uppercase tracking-[0.25em] text-reach-black/60" data-id="element-897" data-mp="2dc1hm1jnk5fl">
                  <Calendar size={14} className="text-reach-red" aria-hidden="true" data-id="element-898" data-mp="3oshzs2mld065" />
                  Weekly Schedule
                </h4>
                <ul className="border-t border-black/10" data-id="element-899" data-mp="3jtwys0zimcgn">
                  {program.slots.map(slot => <li key={`${slot.days}-${slot.time}`} className="flex items-baseline justify-between gap-4 border-b border-black/5 py-2.5" data-id="element-900" data-mp="3qzh7ymebniqr">
                      <span className="font-bebas text-lg tracking-wider" data-id="element-901" data-mp="4oc10ccvb2yl">{slot.days}</span>
                      <span className="font-inter text-sm font-semibold text-reach-black" data-id="element-902" data-mp="9n6o3qhvbdoi">
                        {slot.time}
                      </span>
                    </li>)}
                </ul>
              </div>

              <ul className="mb-7 space-y-2.5" data-id="element-903" data-mp="3i4t4n1sb4b4l">
                {program.detail.map(item => <li key={item} className="flex items-start gap-2.5" data-id="element-904" data-mp="3mw1efyxjtyia">
                    <Check size={16} className="mt-0.5 shrink-0 text-reach-red" aria-hidden="true" data-id="element-905" data-mp="2pgf6mm17xet1" />
                    <span className="font-inter text-sm text-reach-black/85" data-id="element-906" data-mp="2ufia421jvcyw">{item}</span>
                  </li>)}
              </ul>

              <div className="mb-7" data-id="element-907" data-mp="1bj2s4icjypkn">
                <p className="font-bebas text-3xl tracking-wide text-reach-black md:text-4xl" data-id="element-908" data-mp="1bi1cs1oi7gx4">
                  {program.priceLabel}
                </p>
                {program.priceOptions && <ul className="mt-2 space-y-1" data-id="element-909" data-mp="12liox3v4qj7e">
                    {program.priceOptions.map(option => <li key={option} className="font-inter text-sm text-reach-black/80" data-id="element-910" data-mp="sli39b9sfr01">
                        {option}
                      </li>)}
                  </ul>}
              </div>

              <div className="mt-auto flex flex-col gap-3 sm:flex-row sm:items-center" data-id="element-911" data-mp="ju9comtz5gc4">
                <Link to="/book" className="btn-primary" data-id="element-912" data-mp="euwej5xnkmu8">
                  Book Free Athlete Evaluation
                  <ArrowRight size={16} className="ml-2" aria-hidden="true" data-id="element-913" data-mp="9va4t6h19oq6" />
                </Link>
                <Link to="/fall-2026" className="btn-secondary" data-id="element-914" data-mp="4vnr6vxam6gu">
                  View Fall 2026 Schedule
                </Link>
              </div>
            </div>
          </article>)}
      </div>
    </section>;
}
function SpeedSchoolCallout() {
  return <section className="bg-white py-16 md:py-20" data-id="element-915" data-mp="1jrxb9qyf1yyn">
      <div className="mx-auto flex max-w-4xl flex-col items-start gap-6 border-l-4 border-reach-red bg-reach-gray p-8 md:flex-row md:items-center md:justify-between md:p-10" data-id="element-916" data-mp="1jrf96dp2oqit">
        <div data-id="element-917" data-mp="1a1vs9dkx76ql">
          <p className="mb-2 font-inter text-xs font-semibold uppercase tracking-[0.25em] text-reach-red" data-id="element-918" data-mp="1a1c7lp3vy48v">
            {SPEED_SCHOOL.eyebrow}
          </p>
          <h2 className="mb-3 font-bebas text-3xl tracking-wide md:text-4xl" data-id="element-919" data-mp="111pf5st4w8ry">
            Speed Training and Testing
          </h2>
          <p className="max-w-xl font-inter text-base leading-relaxed text-reach-black/80" data-id="element-920" data-mp="161lirqxx5y6z">
            {SPEED_SCHOOL.summary} {SPEED_SCHOOL.bothSessions}, {SPEED_SCHOOL.dropIn},{' '}
            {SPEED_SCHOOL.cap}.
          </p>
        </div>
        <Link to="/speed-school" className="btn-secondary shrink-0" data-id="element-921" data-mp="w4gyjwnmwcst">
          See Speed School
          <ArrowRight size={16} className="ml-2" aria-hidden="true" data-id="element-922" data-mp="cinfqbcqulid" />
        </Link>
      </div>
    </section>;
}
function Methodology() {
  return <section className="relative overflow-hidden bg-reach-black py-20 text-white md:py-24" data-id="element-923" data-mp="mf0evor25rki">
      <div className="pointer-events-none absolute -right-40 top-1/4 h-1 w-[50%] rotate-[6deg] bg-reach-red opacity-30" data-id="element-924" data-mp="hfe3zlypcnev" />
      <div className="mx-auto max-w-container px-4 md:px-8" data-id="element-925" data-mp="ve40p0hm0l2p">
        <div className="mx-auto max-w-3xl text-center" data-id="element-926" data-mp="re3f8vw3f9m5">
          <p className="mb-3 font-inter text-xs font-semibold uppercase tracking-[0.3em] text-reach-red-light" data-id="element-927" data-mp="rdl997jmph11">
            How We Train
          </p>
          <h2 className="mb-5 font-bebas text-4xl leading-none tracking-wide md:text-6xl" data-id="element-928" data-mp="105n7r0a50n8o">
            Every Day Has A Purpose
          </h2>
          <p className="font-inter text-base leading-relaxed text-white md:text-lg" data-id="element-929" data-mp="1f3nwnacllytb">
            Speed and strength work are scheduled by day. Athletes train specific qualities through a
            planned weekly progression, not a random workout.
          </p>
        </div>
        <div className="mx-auto mt-10 grid max-w-4xl grid-cols-1 gap-5 md:grid-cols-2" data-id="element-930" data-mp="glvcf0tf7jdu">
          <article className="border border-white/10 bg-white/[0.04] p-6 md:p-8" data-id="element-931" data-mp="bn1xd3yhjkbk">
            <h3 className="mb-4 flex items-center gap-3 font-bebas text-3xl tracking-wide" data-id="element-932" data-mp="7mruw19wjc1g">
              <Zap size={22} className="text-reach-red-light" aria-hidden="true" data-id="element-933" data-mp="14c8x269oefye" />
              Speed Focus
            </h3>
            <p className="font-inter leading-relaxed text-white/85" data-id="element-934" data-mp="zeh6bfkrozvs">
              Acceleration, change of direction, top speed, and sport-specific movement.
            </p>
          </article>
          <article className="border border-white/10 bg-white/[0.04] p-6 md:p-8" data-id="element-935" data-mp="qdizyqmuwga1">
            <h3 className="mb-4 flex items-center gap-3 font-bebas text-3xl tracking-wide" data-id="element-936" data-mp="3g2l03jys9137">
              <Dumbbell size={22} className="text-reach-red-light" aria-hidden="true" data-id="element-937" data-mp="3b38cuy401s03" />
              Strength Focus
            </h3>
            <p className="font-inter leading-relaxed text-white/85" data-id="element-938" data-mp="1qlzazrq45kok">
              Lower body, upper body, and total body strength work across the week.
            </p>
          </article>
        </div>
      </div>
    </section>;
}
function NextStepBand() {
  return <section className="bg-reach-red py-16 md:py-20" data-id="element-939" data-mp="24c2r00yegi5k">
      <div className="mx-auto max-w-container px-4 text-center md:px-8" data-id="element-940" data-mp="24dm6hpc8ep6a">
        <p className="mb-3 font-inter text-xs font-semibold uppercase tracking-[0.3em] text-white" data-id="element-941" data-mp="29acncevv1osr">
          Next Step
        </p>
        <h2 className="mb-4 font-bebas text-5xl tracking-wide text-white md:text-7xl" data-id="element-942" data-mp="2eclh3dgk4uvx">
          Start With A Free Evaluation
        </h2>
        <p className="mx-auto mb-10 max-w-2xl font-inter text-lg text-white md:text-xl" data-id="element-943" data-mp="2nbp0yjnjtebh">
          Groups are capped at 10 athletes. The fall season starts {SEASON.start}.
        </p>
        <div className="mx-auto flex max-w-md flex-col items-stretch justify-center gap-4 sm:max-w-none sm:flex-row sm:items-center" data-id="element-944" data-mp="sx5z8jatzeui">
          <Link to="/book" className="inline-flex min-h-[44px] items-center justify-center rounded-[4px] bg-white px-6 font-inter text-sm font-semibold uppercase tracking-wide text-reach-black transition-all duration-200 ease-out hover:-translate-y-[3px] hover:bg-reach-black hover:text-white md:min-h-[48px] md:text-base" data-id="element-945" data-mp="1w94lyo1ko58i">
            Book Free Athlete Evaluation
          </Link>
          <Link to="/pricing" className="btn-secondary-dark sm:w-auto" data-id="element-946" data-mp="2f5ctxzlyyu7i">
            View Training Rates
          </Link>
        </div>
      </div>
    </section>;
}